module.exports = __webpack_public_path__ + "img/twitter.35369cb7.svg";